export default function statusToVariant(state) {
    return ["light", "secondary", "danger", "success", "dark", "warning"][
        state
    ];
}
